// extracted by mini-css-extract-plugin
export default {"root":"IconShieldCheck_root__8tFT1"};